import React from 'react';

export const ChevronRightWhiteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_8321_1937"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="4"
        width="9"
        height="15"
      >
        <path
          d="M8.30146 6.69927C7.90146 6.29927 7.90146 5.69927 8.30146 5.29927C8.50146 5.09927 8.70146 4.99927 9.00147 4.99927C9.30147 4.99927 9.50146 5.09927 9.70146 5.29927L15.7015 11.2993C16.1015 11.6993 16.1015 12.2993 15.7015 12.6993L9.70146 18.6993C9.30146 19.0993 8.70146 19.0993 8.30146 18.6993C7.90146 18.2993 7.90146 17.6993 8.30146 17.2993L13.6015 11.9993L8.30146 6.69927Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_8321_1937)">
        <rect width="24" height="24" fill="white" />
        <rect width="24" height="24" fill="white" />
      </g>
    </svg>
  );
};
